import { useEffect, useState } from 'react';
import defaults from '@branding/brand.json';

export interface Branding {
  productName: string;
  shortName: string;
  tagline: string;
  reportTitle: string;
  alertPrefix: string;
}

let cached: Branding = defaults as Branding;
let loading: Promise<Branding> | null = null;

/** Branding from branding/brand.json, with the server's PRODUCT_NAME override applied. */
export function useBranding(): Branding {
  const [b, setB] = useState(cached);
  useEffect(() => {
    loading ??= fetch('/api/public/branding')
      .then((r) => (r.ok ? (r.json() as Promise<Branding>) : cached))
      .catch(() => cached)
      .then((v) => (cached = v));
    void loading.then(setB);
  }, []);
  return b;
}

export function useDocumentTitle(page: string | null): void {
  const b = useBranding();
  useEffect(() => {
    document.title = page ? `${page} | ${b.productName}` : b.productName;
  }, [page, b.productName]);
}
